import { AccredibleResponsiveBreakpoint } from '@accredible-frontend-v2/utils/responsive-helper';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  ViewEncapsulation,
} from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { SwiperOptions } from 'swiper';
import { LocalCourse } from '../../models/course.model';

@Component({
  selector: 'cf-trending-courses',
  templateUrl: './trending-courses.component.html',
  styleUrls: ['./trending-courses.component.scss'],
  // ViewEncapsulation.None in order to be able to style swiper without using ::ng-deep
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrendingCoursesComponent {
  private readonly _deviceDetector = inject(DeviceDetectorService);

  title = input('');
  courses = input<LocalCourse[]>();
  isLoading = input(true);

  isTabletOrMobile = this._deviceDetector.isTablet() || this._deviceDetector.isMobile();

  options: SwiperOptions = {
    slidesPerGroup: 1,
    spaceBetween: 30,
    slidesOffsetAfter: 15,
    breakpoints: {
      [AccredibleResponsiveBreakpoint.SM]: {
        slidesPerGroup: 2,
        slidesOffsetAfter: 30,
        spaceBetween: 40,
      },
      [AccredibleResponsiveBreakpoint.LG]: {
        slidesPerGroup: 3,
        slidesOffsetAfter: 30,
        spaceBetween: 40,
      },
      [AccredibleResponsiveBreakpoint.VL]: {
        slidesPerGroup: 4,
        slidesOffsetAfter: 30,
        spaceBetween: 40,
      },
      [AccredibleResponsiveBreakpoint.SL]: {
        slidesPerGroup: 5,
        slidesOffsetAfter: 30,
        spaceBetween: 40,
      },
    },
  };
}
